import { IonLabel, IonChip, IonIcon, IonButton } from "@ionic/react";
import {
  closeCircle,
  closeOutline,
  person,
} from "ionicons/icons";

import "./ContactChips.css";

export interface ContactChipItem {
  _id?: string;
  Name?: string;
  [key: string]: unknown;
}

interface ContactChipsProps {
  contacts: ContactChipItem[];
  onRemoveContact: (contact: ContactChipItem) => void;
  onClearContacts: () => void;
}

const ContactChips: React.FC<ContactChipsProps> = ({
  contacts,
  onRemoveContact,
  onClearContacts,
}) => {
  return (
    <div className="contact-chips-container">
      {contacts &&
        contacts.map((contact, i: number) => {
          return (
            <IonChip color="primary" key={i}>
              <IonIcon slot="start" icon={person} />
              <IonLabel>{contact.Name}</IonLabel>
              <IonIcon
                icon={closeCircle}
                onClick={() => onRemoveContact(contact)}
              />
            </IonChip>
          );
        })}

      {contacts && Array.isArray(contacts) && contacts.length > 0 && (
        <IonButton
          className="contact-chips-clear-button ion-text-capitalize ion-float-right"
          fill="outline"
          onClick={onClearContacts}
          size="small"
          color="secondary"
        >
          Clear
          <IonIcon slot="end" icon={closeOutline} />
        </IonButton>
      )}
    </div>
  );
};

export default ContactChips;
